module.exports = __webpack_public_path__ + "img/app-store.eea69c66.svg";